import { IApiError } from '@/models/apiError.model';
import { SupportedLocales } from '@/models/localization.model';

export const LOCALES_SLICE_NAME = 'locales';

export interface LocalesState {
  availableLocales: SupportedLocales[] | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: LocalesState = {
  availableLocales: null,
  isLoading: false,
  error: null,
};
